import styles from "./dentalexaminationchart.module.scss";

export default function DentalExaminationChart({
  extraData,
  getHighlightedText,
}) {
  const keys = Object.keys(extraData);
  return (
    <div className={styles.wrap}>
      <table className={styles.table}>
        <tbody>
          {/*Labels*/}
          <tr className={styles.headerRow}>
            <td
              className={styles.cell}
              data-id="empty_label"
            >
              <span data-id="container-break">
                {getHighlightedText("", "empty_label")}
              </span>
            </td>
            {keys.map((key) => {
              return (
                <td
                  key={key}
                  className={styles.centerCell}
                  data-id={key}
                >
                  <span data-id="container-break">
                    {getHighlightedText(key, { key })}
                  </span>
                </td>
              );
            })}
          </tr>
          {/*probing*/}
          <tr>
            <td className={styles.probingLabelWrap}>
              <tr>
                <td
                  className={styles.probingLabel}
                  data-id="probing_label"
                >
                  <span data-id="container-break">
                    {getHighlightedText("Probing", "probing_label")}
                  </span>
                </td>

                <td
                  className={styles.vlColumn}
                  data-id="vestibular_lingual_column"
                >
                  <div className={styles.stack}>
                    <div
                      data-id="vestibular_label"
                      className={styles.vlTop}
                    >
                      <span data-id="container-break">
                        {getHighlightedText("Vestibular", "vestibular_label")}
                      </span>
                    </div>
                    <div data-id="lingual_label" className={styles.vlBottom}>
                      <span data-id="container-break">
                        {getHighlightedText("Lingual", "lingual_label")}
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
            </td>
            {keys.map((key) => {
              return (
                <td
                  key={key}
                  className={styles.valueCell}
                >
                  <div className={styles.stack}>
                    {/*vestibular*/}
                    <div className={styles.valueRowTop}>
                      <div
                        data-id={"vestibular_label_one"}
                        className="dentalExamMultiCell"
                      >
                        <span data-id="container-break">
                          {getHighlightedText(
                            extraData[key].probing.vestibular[0],
                            "vestibular_label_one"
                          )}
                        </span>
                      </div>
                      <div
                        data-id={"vestibular_label_two"}
                        className="dentalExamMultiCell"
                      >
                        <span data-id="container-break">
                          {getHighlightedText(
                            extraData[key].probing.vestibular[1],
                            "vestibular_label_two"
                          )}
                        </span>
                      </div>
                      <div
                        data-id={"vestibular_label_three"}
                        className="dentalExamMultiCell"
                      >
                        <span data-id="container-break">
                          {getHighlightedText(
                            extraData[key].probing.vestibular[2],
                            "vestibular_label_three"
                          )}
                        </span>
                      </div>
                    </div>
                    {/*Lingual*/}
                    <div className={styles.valueRow}>
                      <div
                        data-id={"lingual_label_one"}
                        className="dentalExamMultiCell"
                      >
                        <span data-id="container-break">
                          {getHighlightedText(
                            extraData[key].probing.lingual[0],
                            "lingual_label_one"
                          )}
                        </span>
                      </div>
                      <div
                        data-id={"lingual_label_two"}
                        className="dentalExamMultiCell"
                      >
                        <span data-id="container-break">
                          {getHighlightedText(
                            extraData[key].probing.lingual[1],
                            "lingual_label_two"
                          )}
                        </span>
                      </div>
                      <div
                        data-id={"lingual_label_three"}
                        className="dentalExamMultiCell"
                      >
                        <span data-id="container-break">
                          {getHighlightedText(
                            extraData[key].probing.lingual[2],
                            "lingual_label_three"
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                </td>
              );
            })}
          </tr>
          {/*Mobility*/}
          <tr>
            <td
              className={styles.rowLabel}
              data-id="mobility_label"
            >
              <span data-id="container-break">
                {getHighlightedText("Mobility", "mobility_label")}
              </span>
            </td>
            {keys.map((key, index) => {
              const dataId = `mobility_label_${index}`;
              return (
                <td
                  key={key}
                  className={styles.valueCell}
                >
                  <div className={styles.stack}>
                    {/*mobility*/}
                    <div className={styles.valueRow}>
                      <div data-id={dataId} className="dentalExamMultiCell">
                        <span data-id="container-break">
                          {getHighlightedText(extraData[key].mobility, dataId)}
                        </span>
                      </div>
                    </div>
                  </div>
                </td>
              );
            })}
          </tr>
          {/*Percussion*/}
          <tr>
            <td
              className={styles.rowLabel}
              data-id="percussion_label"
            >
              <span data-id="container-break">
                {getHighlightedText("Percussion", "percussion_label")}
              </span>
            </td>
            {keys.map((key, index) => {
              const dataId = `percussion_label_${index}`;
              return (
                <td
                  key={key}
                  className={styles.valueCell}
                >
                  <div className={styles.stack}>
                    {/*percussion*/}
                    <div className={styles.valueRow}>
                      <div data-id={dataId} className="dentalExamMultiCell">
                        <span data-id="container-break">
                          {getHighlightedText(
                            extraData[key].percussion,
                            dataId
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                </td>
              );
            })}
          </tr>
          {/*Palpation*/}
          <tr>
            <td
              className={styles.rowLabel}
              data-id="palpation_label"
            >
              <span data-id="container-break">
                {getHighlightedText("Palpation", "palpation_label")}
              </span>
            </td>
            {keys.map((key, index) => {
              const dataId = `palpation_label_${index}`;
              return (
                <td
                  key={key}
                  className={styles.valueCell}
                >
                  <div className={styles.stack}>
                    {/*palpation*/}
                    <div className={styles.valueRow}>
                      <div data-id={dataId} className="dentalExamMultiCell">
                        <span data-id="container-break">
                          {getHighlightedText(extraData[key].palpation, dataId)}
                        </span>
                      </div>
                    </div>
                  </div>
                </td>
              );
            })}
          </tr>
          {/*Cold Test*/}
          <tr>
            <td
              className={styles.rowLabel}
              data-id="coldtest_label"
            >
              <span data-id="container-break">
                {getHighlightedText("Cold Test", "coldtest_label")}
              </span>
            </td>
            {keys.map((key, index) => {
              const dataId = `cold_test_label_${index}`;
              return (
                <td
                  key={key}
                  className={styles.valueCell}
                >
                  <div className={styles.stack}>
                    {/*Cold test*/}
                    <div className={styles.valueRow}>
                      <div data-id={dataId} className="dentalExamMultiCell">
                        <span data-id="container-break">
                          {getHighlightedText(extraData[key].cold_test, dataId)}
                        </span>
                      </div>
                    </div>
                  </div>
                </td>
              );
            })}
          </tr>
          {/*Electric pulp test*/}
          <tr>
            <td
              className={styles.rowLabel}
              data-id="electricpulptest_label"
            >
              <span data-id="container-break">
                {getHighlightedText(
                  "Electric Pulp Test",
                  "electricpulptest_label"
                )}
              </span>
            </td>
            {keys.map((key, index) => {
              const dataId = `electric_pulp_test_label_${index}`;
              return (
                <td
                  key={key}
                  className={styles.valueCell}
                >
                  <div className={styles.stack}>
                    {/*Electric pulp test*/}
                    <div className={styles.valueRow}>
                      <div data-id={dataId} className="dentalExamMultiCell">
                        <span data-id="container-break">
                          {getHighlightedText(
                            extraData[key].electric_pulp_test,
                            dataId
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                </td>
              );
            })}
          </tr>
          {/*Bite Test*/}
          <tr>
            <td
              className={styles.rowLabel}
              data-id="bitetest_label"
            >
              <span data-id="container-break">
                {getHighlightedText("Bite Test", "bitetest_label")}
              </span>
            </td>
            {keys.map((key, index) => {
              const dataId = `bite_test_label_${index}`;
              return (
                <td
                  key={key}
                  className={styles.valueCell}
                >
                  <div className={styles.stack}>
                    {/*bite test**/}
                    <div className={styles.valueRow}>
                      <div data-id={dataId} className="dentalExamMultiCell">
                        <span data-id="container-break">
                          {getHighlightedText(extraData[key].bite_test, dataId)}
                        </span>
                      </div>
                    </div>
                  </div>
                </td>
              );
            })}
          </tr>
          {/*Heat Test*/}
          <tr>
            <td
              className={styles.rowLabel}
              data-id="heattest_label"
            >
              <span data-id="container-break">
                {getHighlightedText("Heat Test", "heattest_label")}
              </span>
            </td>
            {keys.map((key, index) => {
              const dataId = `heat_test_label_${index}`;
              return (
                <td
                  key={key}
                  className={styles.valueCell}
                >
                  <div className={styles.stack}>
                    {/*Heat Test**/}
                    <div className={styles.valueRow}>
                      <div data-id={dataId} className="dentalExamMultiCell">
                        <span data-id="container-break">
                          {getHighlightedText(extraData[key].heat_test, dataId)}
                        </span>
                      </div>
                    </div>
                  </div>
                </td>
              );
            })}
          </tr>
          {/*Discolouration*/}
          <tr>
            <td
              className={styles.rowLabel}
              data-id="discolouration_label"
            >
              <span data-id="container-break">
                {getHighlightedText("Discolouration", "discolouration_label")}
              </span>
            </td>
            {keys.map((key, index) => {
              const dataId = `discoloration_label_${index}`;
              return (
                <td
                  key={key}
                  className={styles.valueCell}
                >
                  <div className={styles.stack}>
                    {/*Discolouration*/}
                    <div className={styles.valueRow}>
                      <div data-id={dataId} className="dentalExamMultiCell">
                        <span data-id="container-break">
                          {getHighlightedText(
                            extraData[key].discoloration,
                            dataId
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                </td>
              );
            })}
          </tr>
        </tbody>
      </table>
    </div>
  );
}
